// extracted by mini-css-extract-plugin
export default {"tableHead":"PackageItemList_tableHead__CDFWW","tableBodyRow":"PackageItemList_tableBodyRow__OsSNR"};